<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-t"><a id="page_iv">To the guys in my life:</a></p><a id="page_iv">
<p class="ded">Ryan, Connor, DanO</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Dedication.vue?169db9a4